import { useCallback, useState } from 'react';

//services
import { postExamAnswers } from 'services/sessions';

//interfaces
import {
  IExamAnswerBody,
  IExamAnswerResult,
} from 'services/interfaces/IExam';

export const usePostExamAnswers = () => {
  const [examResult, setExamResult] = useState<IExamAnswerResult | null>(null);

  const handlePostExamAnswers = useCallback(
    async (
      idBasis: string | number,
      idModule: string | number,
      idExam: string | number,
      body: IExamAnswerBody
    ) => {
      try {
        const resp = await postExamAnswers(idBasis, idModule, idExam, body);
        if (resp) setExamResult(resp);
        return resp;
      } catch (e) {
        console.log(e);
      }
    },
    []
  );

  return { examResult, handlePostExamAnswers };
};
